import { all } from "redux-saga/effects";

import { initAppSaga } from "./init/sagas";
import { rootSagas } from "./root-sagas";

function buildRootSaga(appSagas, pageSagas) {
  function* rootSaga() {
    yield all([
      ...rootSagas,
      ...appSagas,
      ...pageSagas,
      // This must happen last, so previously declared sagas
      // can receive this action.
      initAppSaga(),
    ]);
  }

  return rootSaga;
}

export { buildRootSaga };
